module.exports = __webpack_public_path__ + "img/rectangle.5c638bcc.svg";